import type { ApiError } from "@circle-react/config/CustomErrors";
import { reactQueryGet } from "@circle-react/helpers/backendRequestHelpers";
import { internalApi } from "@circle-react/helpers/urlHelpers";
import { createQueryKeyFactory } from "@circle-react/lib/queries/createQueryKeyFactory";
import { LIVE_ROOM_LIVE_NOW_PER_PAGE } from "@circle-react/lib/queries/liveRoomsConstants";
import { queryClient } from "@circle-react/providers/QueryClient/reactQueryConfig";
import type { Room } from "@circle-react/types/Live/Room";
import { queryOptions } from "react-query";

export const liveRoomKey = createQueryKeyFactory("live-room");

interface LiveNowResponse {
  records: Room[];
}

interface LiveRoomListResponse {
  count: number;
  has_next_page: boolean;
  page_count: number;
  records: Room[];
}

export const liveRoomQueries = {
  liveNow: () =>
    queryOptions<LiveNowResponse, ApiError>({
      queryKey: liveRoomKey.key("live-now", LIVE_ROOM_LIVE_NOW_PER_PAGE),
      queryFn: () =>
        reactQueryGet<LiveNowResponse>(
          internalApi.liveStreams.liveNow({
            params: { per_page: LIVE_ROOM_LIVE_NOW_PER_PAGE },
          }),
        ),
    }),
  detail: (id?: string | number) =>
    queryOptions<Room, ApiError>({
      queryKey: liveRoomKey.key("detail", id || "disabled"),
      queryFn: () =>
        id
          ? reactQueryGet<Room>(internalApi.liveStreams.show({ id }))
          : Promise.reject(new Error("liveRoomId is required")),
      enabled: Boolean(id),
    }),
  settingsList: (params: Record<string, unknown>) =>
    queryOptions<LiveRoomListResponse, ApiError>({
      queryKey: liveRoomKey.key("settings-list", JSON.stringify(params)),
      queryFn: () =>
        reactQueryGet<LiveRoomListResponse>(
          internalApi.liveStreams.index({ params }),
        ),
    }),
};

export const liveRoomInvalidations = {
  all: () => queryClient.invalidateQueries({ queryKey: liveRoomKey.root() }),
};
